<template>
  <div class="text-center">
    <v-dialog persistent v-model="msgshow" max-width="600">
      <v-card>
        <v-card-title :class="{
            'headline': true,
            'primary--text': !$vuetify.theme.dark,
            'foreground--text': !$vuetify.theme.dark,
          }"
          style="box-shadow: 1px 1px 5px 3px color-mix(in srgb, var(--v-shadow-base) 50%, transparent);">
          {{getTitle()}}
        </v-card-title>
        <v-card-text class="pt-5">
          <p style="font-size: 16px !important;" v-html="msg.data.text"></p>
        </v-card-text>
        <v-card-actions style="justify-content: center">
          <v-btn class="btn-quote" @click="hidemsg()">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { triggerRef } from "vue";
import { mapState, mapMutations } from "vuex";
export default {
  computed: {
    ...mapState(["msg", "menu", "app"]),
    msgshow: {
      get: function () {
        return this.msg.show;
      },
      set: function (value) {
        this.tooglemsg(value);
      },
    },
  },
  created() {},
  methods: {
    ...mapMutations(["tooglemsg", "hidemsg"]),
    getTitle() {
      if (this.msg.title) {
        return this.msg.title;
      } else {
        return this.msg.data.type
          .replace("warning", "Aviso")
          .replace("error", "Ops, algo deu errado")
          .replace("success", "Sucesso");
      }
    },
  },
};
</script>
